export const usePrice = (cents: number): string => {
 if (!cents) return "";
 const conversion = cents / 100;
 let formattedValue = parseFloat(conversion.toFixed(2)).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
 return `${formattedValue}`;
};
